import request from '../request'

// 获取手机验证码
export function getMobileCaptcha(data) {
  return request({
    url: '/app/auth/captcha/mobile',
    method: 'post',
    data,
  })
}

// 获取图形验证码
export function getLoginCaptcha(params) {
  return request({
    url: '/app/auth/login/captcha',
    method: 'get',
    params,
  })
}

// 手机验证码登录
export function mobileLogin(data) {
  return request({
    url: '/app/auth/login/mobile',
    method: 'post',
    data,
  })
}

// 退出登录
export function logout(data) {
  return request({
    url: '/app/auth/logout',
    method: 'post',
    data,
  })
}

// 获取用户详情
export function getUserProfile() {
  return request({
    url: '/app/user/profile',
    method: 'get',
  })
}
